import { css } from '@emotion/css';

import { nonMobileMediaQuery } from '../../../constants';
import { m } from '../../../motif/m';

export const footerItemContainerCss = css`
  margin: ${m('--spacing-s')} 0;

  ${nonMobileMediaQuery} {
    margin: ${m('--spacing-xxs')} 0;
  }
`;

export const footerItemCss = css`
  color: ${m('--action-text-default-color')};
  /* Set font-family here or the var from the default motif is used */
  font-family: ${m('--font-family')};
  font-size: ${m('--footer-desktop-font-size')};
  font-weight: ${m('--action-desktop-font-weight')};
  text-decoration: none;
  white-space: pre-wrap;

  @media (hover: hover) {
    &:hover {
      color: ${m('--action-text-hover-color')};
      text-decoration: underline;
      text-decoration-thickness: ${m('--spacing-xxxs')};
      text-underline-offset: ${m('--spacing-xxxs')};
    }
  }

  ${nonMobileMediaQuery} {
    margin: 0;
    margin-inline-end: ${m('--spacing-s')};
  }
`;
